// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const resetReportIsScrollable = () => ({
    type: actions.RESET_REPORT_IS_SCROLLABLE
});

export const toggleReportIsScrollable = () => ({
    type: actions.TOGGLE_REPORT_IS_SCROLLABLE
});



// WEBPACK FOOTER //
// ./src/reports/shared/action-creators/reset-report-is-scrollable.js